import React from "react";
import { normalizeNumbers } from "@SeemplicityDev/shared";
import useWidgetFilterNavigator from "../../useWidgetFilterNavigator";

export interface CriticalCountCellProps {
  criticalCount?: number;
  totalCount?: number;
  filterToExecute?: string;
  currentScope?: string;
}

const CriticalCountCell: React.FC<CriticalCountCellProps> = ({
  criticalCount,
  totalCount,
  filterToExecute,
  currentScope,
}) => {
  const { onFilterClick } = useWidgetFilterNavigator({
    filterToExecute: filterToExecute,
    filterId: null,
    scopeToExecute: null,
    scopeId: currentScope,
  });

  const onCriticalFindingsClick = () => {
    onFilterClick([["in", "remediation_item.severity", "3"]]);
  };

  return (
    <div className={"scopes-graph-col-findings-wrap"}>
      <div
        className={`scopes-graph-col-total-count ${
          totalCount === 0 ? "is-disabled" : ""
        }`}
      >
        {normalizeNumbers(totalCount!)}
      </div>
      <div
        className={`critical-count-wrap ${
          criticalCount === 0 ? "is-disabled" : ""
        }`}
        onClick={() => criticalCount !== 0 && onCriticalFindingsClick()}
      >
        <div className="dot-red" />
        <span className="critical-count">
          {normalizeNumbers(criticalCount!)}
        </span>
      </div>
    </div>
  );
};

export default CriticalCountCell;
